

import React from 'react';
import PropTypes from 'prop-types';
import { Input, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { faCalculator, faList } from '@fortawesome/free-solid-svg-icons';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import 'assets/css/componentStyles/paginationBar.css';

const MAX_PAGES_TO_SHOLW = 3;
const OPTIONS = [10, 20, 30, 40, 50]

const PaginationControls = ({ total, pageIndex, pageCount, pageSize, setPageSize, canPreviousPage, canNextPage, previousPage, nextPage, gotoPage }) => {
    // Function to render pagination page numbers
    const renderPageNumbers = () => {
        const currentPage = pageIndex + 1; // Adjust for zero-based index
        
        const middlePage = Math.floor(MAX_PAGES_TO_SHOLW / 2);
        let startPage = currentPage - middlePage;
        let endPage = currentPage + middlePage;

        if (startPage < 1) {
            startPage = 1;
            endPage = MAX_PAGES_TO_SHOLW;
        }

        if (endPage > pageCount) {
            endPage = pageCount;
            startPage = pageCount - MAX_PAGES_TO_SHOLW + 1;
            if (startPage < 1) {
                startPage = 1;
            }
        }

        const createPaginationItem = (key, pageNumber, isActive = false) => (
            <PaginationItem key={key} active={isActive}>
                <PaginationLink
                    onClick={() => gotoPage(pageNumber - 1)}
                    className={isActive ? 'active-page' : 'inactive-page'}
                    disabled={pageNumber===null}
                >
                    {pageNumber || '...'}
                </PaginationLink>
            </PaginationItem>
        );

        const pages = [];

        if (startPage > MAX_PAGES_TO_SHOLW) {
            pages.push(createPaginationItem("first", 1, false));
            pages.push(createPaginationItem("ellipsisToFirst", null, false));
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(createPaginationItem(i, i, i === currentPage));
        }

        if (pageCount > endPage) {
            pages.push(createPaginationItem("ellipsisToLast", null, false));
            pages.push(createPaginationItem("last", pageCount, false));
        }

        return pages;
    };

    return (
        <div className="flex-center pagination-right mt-5">
            <div style={{ marginTop: "-0.4cm" }}>
                <IconButtonWithTooltip className="input-select" translationId='list.total' onClick={() => {}} icon={faCalculator} type="link" />
                {total}
            </div>
            <div style={{ marginTop: "-0.4cm" }}>
                <IconButtonWithTooltip className="input-select" translationId='userSetting.list_page_length' onClick={() => {}} icon={faList} type="link" />
            </div>
            <Input
                id="itemsPerPage"
                type="select"
                value={pageSize}
                className="input-select"
                onChange={(e) => setPageSize(Number(e.target.value))}
            >
                {OPTIONS.map((value) => (
                    <option key={value} value={value}>
                        {value}
                    </option>
                ))}
            </Input>
            <Pagination>
                <PaginationItem disabled={!canPreviousPage}>
                    <PaginationLink
                        previous
                        onClick={() => previousPage()}
                        className={!canPreviousPage ? 'pagination-link' : 'inactive-page'}
                        aria-label="Previous page"
                    />
                </PaginationItem>
                {renderPageNumbers()}
                <PaginationItem disabled={!canNextPage}>
                    <PaginationLink
                        next
                        onClick={() => nextPage()}
                        className={!canNextPage ? 'pagination-link' : 'inactive-page'}
                        aria-label="Next page"
                    />
                </PaginationItem>
            </Pagination>
        </div>
    );
};

PaginationControls.propTypes = {
    pageIndex: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    setPageSize: PropTypes.func.isRequired,
    canPreviousPage: PropTypes.bool.isRequired,
    canNextPage: PropTypes.bool.isRequired,
    previousPage: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    gotoPage: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.number),
};

export default PaginationControls;
